export default function classNames(...classes: (string | boolean | undefined)[]): string {
  return classes.filter((c) => c !== undefined).join(' ');
}
